export default "__VITE_ASSET__YMrtagVk__"